/**
 * 영업건 「다음 할 일」 판정 (v2.319.0 · Salesforce Next Step · Pipeline Inspection 의 빨간 시계)
 *   7일 넘게 그대로면 ⏰ — 목록 칸(SalesList)과 상세 「활동」(SalesActivitySection)이 같은 판정을 쓴다.
 */
export const NEXT_STEP_STALE_DAYS = 7;

export function isNextStepStale(nextStep: string | null | undefined, nextStepAt: string | null | undefined, status: string): boolean {
  if (!nextStep || !nextStep.trim()) return false;
  if (status === '발행' || status === '판보') return false;
  if (!nextStepAt) return true;
  const t = new Date(nextStepAt).getTime();
  if (!Number.isFinite(t)) return true;
  return Date.now() - t > NEXT_STEP_STALE_DAYS * 86_400_000;
}

/** 「11/05」 */
export function shortDate(d: string | null | undefined): string {
  return d ? d.slice(5, 10).replace('-', '/') : '';
}
